import type { CSSProperties } from "styled-components";
import styled, { css } from "styled-components";

// helpers methods
type BaseFlexProps = Pick<CSSProperties, "alignItems" | "justifyContent" | "gap" | "flexDirection" | "width">;

const alignItemsFunction = ({ alignItems }: BaseFlexProps) =>
    alignItems &&
    css`
        align-items: ${alignItems};
    `;

const justifyContentFunction = ({ justifyContent }: BaseFlexProps) =>
    justifyContent &&
    css`
        justify-content: ${justifyContent};
    `;

const gapFunction = ({ gap }: BaseFlexProps) =>
    gap &&
    css`
        gap: ${gap};
    `;

const flexDirectionFunc = ({ flexDirection }: BaseFlexProps) => flexDirection && `flex-direction: ${flexDirection};`;

export const BaseFlex = styled.div<BaseFlexProps>`
    display: flex;
    width: ${({ width = "auto" }) => width};
    ${alignItemsFunction};
    ${justifyContentFunction};
    ${gapFunction};
    ${flexDirectionFunc};
`;

export const FlexRow = styled(BaseFlex)`
    flex-direction: row;
`;

FlexRow.displayName = "FlexRow";

export const FlexColumn = styled(BaseFlex)`
    flex-direction: column;
`;
FlexColumn.displayName = "FlexColumn";

export const FlexRowReverse = styled(FlexRow)`
    flex-direction: row-reverse;
`;
FlexRowReverse.displayName = "FlexRowReverse";

const FlexColumnReverse = styled(FlexColumn)`
    flex-direction: column-reverse;
`;
FlexColumnReverse.displayName = "FlexColumnReverse";

export const FlexRowFlexStart = styled(FlexRow)`
    justify-content: flex-start;
`;

export const FlexRowFlexEnd = styled(FlexRow)`
    justify-content: flex-end;
`;

export const LeftFlexRow = styled(FlexRow)`
    justify-content: flex-start;
    align-items: center;
`;
LeftFlexRow.displayName = "LeftFlexRow";

export const RightFlexRow = styled(FlexRow)`
    justify-content: flex-end;
    align-items: center;
`;
RightFlexRow.displayName = "RightFlexRow";

export const CenteredFlexRow = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;
CenteredFlexRow.displayName = "CenteredFlexRow";

export const CenteredContent = styled(CenteredFlexRow)`
    height: 100%;
`;

export const CenteredFlexColumn = styled(FlexColumn)`
    align-items: center;
    justify-content: center;
`;
CenteredFlexColumn.displayName = "CenteredFlexColumn";
